/**
 * Defined all event ---
 */
export default {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'LOGOUT',
    CONNECT_SERVER: 'CONNECT_SERVER',
    SEVER_MQTT_MSG: 'SEVER_MQTT_MSG',
    SYS_MSG: 'SYS_MSG',
    ADD_PRODUCT: 'ADD_PRODUCT',
    ADD_NOTIFY: 'ADD_NOTIFY',
    EXPIRE_SESSION: 'EXPIRE_SESSION',
    ZOOM_SCREEN: 'ZOOM_SCREEN',
    CHANGE_CABINET: 'CHANGE_CABINET',
    LOGIN_HIKVISION: 'LOGIN_HIKVISION',
};
